import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function WidgetCard({ label, value, icon, onInfo }) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{ background: "linear-gradient(135deg, #FFFFFF 0%, #F4F6F8 100%)" }}
      px={{ xs: 2, ms: 3 }}
      py={{ xs: 1.5, ms: 2 }}
      borderRadius="15px"
      height="100%"
    >
      <Box display="flex" alignItems="center">
        {!isMobile && icon}
        <Box ml={isMobile ? undefined : 2}>
          <Typography fontSize={{ xs: 16, sm: 18, md: 24 }} fontWeight={500}>
            {value}
          </Typography>
          <Typography fontSize={{ xs: 12, sm: 16, md: 16 }}>{label}</Typography>
        </Box>
      </Box>
      {onInfo && (
        <IconButton aria-label="info" onClick={onInfo}>
          <InfoOutlinedIcon />
        </IconButton>
      )}
    </Box>
  );
}
